import { useNavigate } from "react-router-dom";
import map from "../assets/images/map.webp";
import camera from "../assets/images/camera.webp";
import resort from "../assets/images/localResort.webp"
import cuisine from "../assets/images/cuisine.webp"
import cafe from "../assets/images/cafe.webp"
import road from "../assets/images/roud.webp"

const HeroNavigationMobile = () => {
    const navigate = useNavigate();
    const navItems = [
        { img: map, path: '/', label: 'برنامه سفر', comingSoon: true },
        { img: camera, path: '/places/category/جاذبه%E2%80%8Cهای%20دیدنی', label: 'جای دیدنی' },
        { img: cuisine, path: '/places/category/رستوران', label: '  رستوران' },
        { img: cafe, path: '/places/category/کافه', label: 'کافه' },
        { img: resort, path: '/places/category/اقامتگاه', label: 'اقامتگاه' },
        { img: road, path: '/', label: 'تجربه خاص', comingSoon: true }
    ];
    return (
        <div className="mx-auto">
            <div className="bg-white rounded-3xl p-2 grid grid-cols-3 gap-2 w-full  font-myYekanDemibold">
                {navItems.map((item, i) => (
                    <div key={i} className="flex flex-col items-center">
                        <button
                            onClick={() => navigate(item.path)}
                            className="relative flex items-center justify-center w-[60px] h-[60px]  border-[#CFD6DC] rounded-lg"
                        >
                            <img src={item.img} alt={item.label} className="rounded-lg" />
                            {item.comingSoon && (
                                <span className="absolute top-2 right-2 font-myYekanDemibold bg-white/80 px-1 py-0.2 text-xs rounded shadow-sm text-gray-700">
                                    به زودی
                                </span>
                            )}
                        </button>
                        <span className="mt-1 text-xs font-myYekanDemibold text-center w-[100px]">
                            {item.label}
                        </span>
                    </div>
                ))}
            </div>
        </div>
    );
};
export default HeroNavigationMobile;